import { css } from 'styled-components'

export const icoSet = css`
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: 100% 100%;
`

export const bgSet = css`
  background-repeat: no-repeat;
  background-position: 50% 50%;
`
